import I18n from 'I18n';
import { CreditIconWithTooltip } from 'usage-based-billing-components-lib/components';
import { useGetGovernanceStatusQuery } from '../../../__generated__/chirp/com/hubspot/usagebasedbilling/experience/rpc/UsageBasedBillingGovernanceRpc.hooks';
import { useTrackUsageContextStandalone } from '../../usage-tracking/contexts/TrackUsageContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const CustomerAgentCreditsIcon = () => {
  var _data$featureStates;
  const {
    data,
    loading
  } = useGetGovernanceStatusQuery();
  const disabled = !(data !== null && data !== void 0 && (_data$featureStates = data.featureStates) !== null && _data$featureStates !== void 0 && (_data$featureStates = _data$featureStates.CUSTOMER_AGENT_TEXT_CONVERSATION) !== null && _data$featureStates !== void 0 && _data$featureStates.isEnabled);
  const usageTracker = useTrackUsageContextStandalone();
  return loading ? null : /*#__PURE__*/_jsx(CreditIconWithTooltip, {
    usageTracker: usageTracker,
    screen: "routing-rules",
    disabled: disabled,
    featureName: I18n.text('routing-ui.routingRules.options.customerAgent')
  });
};
CustomerAgentCreditsIcon.displayName = 'CustomerAgentCreditsIcon';